import Velocity from 'velocity-animate'
import 'velocity-animate/velocity.ui'
import { isFunction } from 'lodash-es'
import logger from '../logger'

// ////////////////////////////////
// Element Animation Transition //
// ////////////////////////////////

export default {
  init() {
    logger('init FadeElementTransition', 'debug')()
  },
  show(element, cb, options = {}) {
    logger('revealing element', 'debug')()

    // set the item to invisible to begin with
    const $el = this.root.querySelector(element)
    Velocity($el, 'stop')
    $el.style.setProperty('opacity', 0)

    const mySequence = [{
      e: $el,
      p: {
        opacity: 1,
      },
      o: {
        duration: options.duration || 300,
        complete() {
          if (isFunction(cb)) cb.call(this)
        },
      },
    }]

    // animate the item in
    Velocity.RunSequence(mySequence)
  },
  hide(element, cb, options = {}) {
    logger('hiding element', 'debug')()

    const $el = this.root.querySelector(element)
    Velocity($el, 'stop')
    $el.style.setProperty('opacity', 1)

    const mySequence = [{
      e: $el,
      p: {
        opacity: 0,
      },
      o: {
        duration: options.duration || 300,
        complete() {
          if (isFunction(cb)) cb.call(this)
        },
      },
    }]

    // animate the item out
    Velocity.RunSequence(mySequence)
  },
}
